import { atom } from 'recoil';

export const teacherStudentState = atom({
  key: 'teacherStudentState',
  default: null,
});
